(() => {
  function sizedUrl(source, width) {
    const url = new URL(source, window.location.href);
    url.searchParams.set('width', String(width));
    return url.toString();
  }

  function replaceExactText(from, to) {
    document.querySelectorAll('h1,h2,h3,a,button,span').forEach((el) => {
      if (el.childElementCount === 0 && el.textContent.trim() === from) el.textContent = to;
    });
  }

  function replaceDirectTextNode(container, from, to) {
    if (!container) return;
    Array.from(container.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === from) node.textContent = node.textContent.replace(from, to);
    });
  }

  function enhanceProductPage() {
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    if (!template.includes('product')) return;

    const buyButtons = document.querySelector('.buy-buttons-block, [class*="buy-buttons"]');
    const promise = document.querySelector('.sl-product-promise');
    const infoBox = document.querySelector('.sl-product-info-box');

    if (buyButtons && promise && !promise.dataset.slPlaced) {
      promise.dataset.slPlaced = 'true';
      promise.classList.add('sl-product-promise--inline');
      buyButtons.after(promise);
      if (infoBox) {
        infoBox.dataset.slPlaced = 'true';
        infoBox.classList.add('sl-product-info-box--inline');
        promise.after(infoBox);
      }
    }

    replaceExactText('You may also like', 'Passt gut dazu');
  }

  function enhanceCartPage() {
    const template = document.querySelector('main[data-template]')?.dataset.template || '';
    if (!template.includes('cart')) return;

    replaceExactText('Cart', 'Warenkorb');
    document.querySelectorAll('.cart-page__title, .cart-title, .cart-page__title h1, .cart-page__title h2, .cart-page__title h3').forEach((el) => replaceDirectTextNode(el, 'Cart', 'Warenkorb'));
    replaceExactText('You may also like', 'Passt gut dazu');
    replaceExactText('View all', 'Alle Produkte ansehen');

    const trust = document.querySelector('.sl-cart-trust');
    const upsell = document.querySelector('.sl-cart-upsell');
    const summary = document.querySelector('.cart-page__summary, .cart-summary, [class*="cart-summary"]');
    if (summary && trust && !trust.dataset.slPlaced) {
      trust.dataset.slPlaced = 'true';
      summary.prepend(trust);
      if (upsell && !upsell.dataset.slPlaced) {
        upsell.dataset.slPlaced = 'true';
        summary.append(upsell);
      }
    }
  }

  function enhance() {
    const logo = document.querySelector('.header-logo');
    if (logo && !logo.getAttribute('aria-label')) logo.setAttribute('aria-label', 'StrengthLab One Startseite');

    document.querySelectorAll('.slx-card img:not([srcset])').forEach((image) => {
      const source = image.getAttribute('src');
      if (!source) return;
      image.srcset = [220, 360, 520, 720].map((width) => `${sizedUrl(source, width)} ${width}w`).join(', ');
      image.sizes = '(max-width: 640px) calc((100vw - 37px) / 2), (max-width: 990px) calc((100vw - 62px) / 2), 25vw';
      image.src = sizedUrl(source, 520);
    });

    enhanceProductPage();
    enhanceCartPage();
    window.setTimeout(enhanceProductPage, 600);
    window.setTimeout(enhanceCartPage, 600);
    window.setTimeout(enhanceCartPage, 1600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance); else enhance();
})();
